import React from "react";
import {useSearchParams} from "react-router-dom";

import MeasureOverviewLayout from "./overview";
import StoreyMeasuresDetails from "./storey-measures";

const ProjectMeasuresLayout: React.FC = () => {
    const [searchParams] = useSearchParams();
    const storeyId = (searchParams.get('storeyId') as string);

    return (
        <>
            {storeyId == null ? (
                <MeasureOverviewLayout/>
            ) : (
                <StoreyMeasuresDetails storeyId={storeyId}/>
            )}
        </>
    )
}

export default ProjectMeasuresLayout;